export enum ProfileType {
  ET = 0,
  BT = 1,
  POWER = 2,
  HYBRID_ET = 3,
  HYBRID_BT = 4,
  INLET_TEMP = 5,
  BT_POWER = 6,
  BT_INLET = 7,
}

export const ProfileTypeString = {
  [ProfileType.ET]: 'profilesview.airtempprofile',
  [ProfileType.BT]: 'profilesview.beantempprofile',
  [ProfileType.POWER]: 'profilesview.powerprofile',
  [ProfileType.HYBRID_ET]: 'profilesview.hybridetprofile',
  [ProfileType.HYBRID_BT]: 'profilesview.hybridbtprofile',
  [ProfileType.INLET_TEMP]: 'profilesview.inlettempprofile',
  [ProfileType.BT_POWER]: 'profilesview.btpowerprofile',
  [ProfileType.BT_INLET]: 'profilesview.btinletprofile',
}

export const ProfileColor = {
  [ProfileType.ET]: 'et' as 'et',
  [ProfileType.BT]: 'bt' as 'bt',
  [ProfileType.POWER]: 'power' as 'power',
  [ProfileType.HYBRID_ET]: 'et' as 'et',
  [ProfileType.HYBRID_BT]: 'bt' as 'bt',
  [ProfileType.INLET_TEMP]: 'inletTemp' as 'inletTemp',
  [ProfileType.BT_POWER]: 'power' as 'power',
  [ProfileType.BT_INLET]: 'inletTemp' as 'inletTemp',
}
